import { forwardRef, ButtonHTMLAttributes } from "react"
import { CSSFn } from "../styles"
import { StyledButton, StyledButtonProps } from "./ButtonStyles"

interface IButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "disabled"> {
  css?: CSSFn
  disabled?: boolean
}

export type ButtonProps = IButtonProps & StyledButtonProps

const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ ...props }: ButtonProps, forwardedRef) => (
  <StyledButton ref={forwardedRef} {...props} />
))

Button.defaultProps = {
  css: undefined,
  disabled: false,
}

Button.displayName = `Button`

export { Button }
